module.exports = __webpack_public_path__ + "img/snapchat.f6d544db.svg";